import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

function NotFoundComponent() {
  const { t } = useTranslation('common')

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '3rem',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{ 
          fontSize: '72px', 
          fontWeight: 'bold', 
          color: '#6c757d',
          marginBottom: '1rem'
        }}>
          404
        </div>
        
        <h1 style={{ 
          color: '#333', 
          marginBottom: '1rem',
          fontSize: '28px'
        }}>
          {t('errors.notFound')}
        </h1>
        
        <p style={{ 
          color: '#666', 
          marginBottom: '2rem',
          lineHeight: '1.5',
          fontSize: '16px'
        }}>
          {t('errors.notFoundMessage')}
        </p>

        <Link
          to="/"
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            textDecoration: 'none',
            padding: '0.75rem 2rem',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: '500'
          }}
        >
          {t('errors.home')}
        </Link>
      </div>
    </div>
  )
}

export const Route = createFileRoute('/$')({
  component: NotFoundComponent,
})
